import React from 'react';
import * as _ from 'lodash';
import $ from 'jquery';

import * as Misc from './../../misc';
import * as StonesStore from './../../stores/stonesStore';
import ProjectScope from './../projectScope/projectScope';
import * as Config from './../../config';
import Iframe from './iframe';
import LoaderView from "./../common/loaderView";
import uuid from 'uuid';
import actionTypes from './../../actionTypes';
import Analytics from './../../analytics';
import ActionTypes from "../../actionTypes";

export default class KitchenVisualizerIFrame extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      iframeLink: '',
      rendered: false,
      iframeOpened: this.props.iframeOpened,
      iframeRender: this.props.iframeRender || false,
      iframeId: uuid.v4(),
      parentUniqueId: null
    };

    document.iframeCanRecieveData = this.iframeCanRecieveData;
  }

  componentDidMount() {

    $(window).resize(() => {

      const frame = $('.review-submit-iframe-wrapper');

      if (!isNaN(window.orientation) && (window.orientation === 0) && frame.hasClass('review-submit-iframe-wrapper--workaround')) {
        frame.removeClass('review-submit-iframe-wrapper--workaround');
        setTimeout(() => {
          frame.addClass('review-submit-iframe-wrapper--workaround');
        }, 300)
      }
    });

    window.$ = $;

    //$(document).on(actionTypes.IFRAME_CAN_RECIEVE_DATA, this.iframeCanRecieveData);
    $(document).on('loader_show', () => {
      this.setState({iframeOpened: false});
    });

    this.setState({
      iframeLink: this.renderIframeLink()
    });

    window.addEventListener("message", (event) => {
      if (event.data.action === "setUniqueIdforQT") {
        this.setState({
          parentUniqueId: event.data.parentUniqueId   // we need to set uniqueID in order to change only this component!
        })
      } else if (event.data.action === "triggerInIframeUpdateKVFeatures" && event.data.parentUniqueId === this.state.parentUniqueId) {
        this.triggerInIframe(actionTypes.UPDATE_KV_FEATURES)
      }
    });

  }

  componentWillReceiveProps(nextProps) {

    nextProps.isSelected && this.setState({
      rendered: true
    });

    const link = this.renderIframeLink();

    if (this.props.fullScreen) {

      if (this.state.iframeOpened && !this.props.switchedToKV && (this.state.iframeLink !== link)
        && !$('#app').hasClass('js--switched')) {

        this.setState({
          iframeLink: link,
          iframeOpened: false,
          iframeRender: false
        }, () => {

          if (this.props.switchedToKV) {
            // console.log('this.stateiframeOpened----->', this.state.iframeOpened);
            this.setState({
              iframeRender: true
            })
          }

        })
      } else if (nextProps.switchedToKV) {

        // console.log('to render');

        this.setState({
          iframeLink: link,
          iframeRender: true
        })
      }

    } else {
      nextProps.iframeOpened && this.setState({
        iframeOpened: true
      });
      (this.state.iframeLink !== link) && this.setState({
        iframeLink: link
      });
    }

    nextProps.iframeOpened && this.props.fullScreen && this.props.switchedToKV && this.setState({
      iframeOpened: true
    });
  }

  renderIframeLink = () => {
    const quote = ProjectScope.quote();
    if (!quote)
      return '';

    const {stone} = quote;
    let {domain, protocol, subDomain} = Misc.extractDomain(window.location.href);
    const featuresToDisplay = [];
    const fabricator = StonesStore.fabricator();
    const fabricatorId = fabricator ? fabricator.Id : 0;

    // console.log(999, domain, fabricator, stone);
    // if (!subDomain && fabricator) {
    //     domain = fabricator.SubDomain + '.' + domain;
    // }
    //
    _.forEach(quote.featuresToDisplay, (quantity, featureID) => {
      const fabricatorFeature = _.find(fabricator.Features, f => f.FeatureId === +featureID);
      if (fabricatorFeature) {
        featuresToDisplay.push(fabricatorFeature.Id);
      }
    });

    let postFix = '/kv';
    if (window.location.port === '9007') {
      domain = 'localhost:9001';
      postFix = '';
    }
    if (Config.kvConfig.isLocal) {
      postFix += "/dev"; // load dev version of KV scripts. works only when executed via main web-site
    }

    let url = (protocol || 'http') + '://' + domain + `${postFix}`;

    const params = stone
      ? `sid=${stone.Id}&fids=${featuresToDisplay.join('.')}&fabricatorId=${fabricatorId}`
      : 'sid=8472&fids=8894.8895.9588';

    const fn = Config.parent.window.kioskGoToKV;
    if (fn) {
      url = '../KitchenVisualizer/index.html';
    }

    return `${url}?${params}`;
  };

  handleViewInVisualizerClick = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendClickEvent('kviframe-view-in-visualizer');
    this.props.openKitchenVisualizerIframe();
  };


  /**
   * KV can also authenticate the user and send back the email and encodedUserId
   * @param kvDocument
   * @param kvUserInfo {object}
   */
  iframeCanRecieveData = (kvDocument, kvUserInfo) => {
    let userInfo = ProjectScope.userInfo();
    //console.log(9999, 'KV said it can receive data.', kvUserInfo);

    if (kvUserInfo && kvUserInfo.encodedUserId) {
      // KV is sending us the credentials for the user that gets logged in
      userInfo = userInfo || {};
      if (kvUserInfo.encodedUserId && userInfo.encodedUserId !== kvUserInfo.encodedUserId) {
        userInfo = Object.assign({}, kvUserInfo);
        userInfo.userId = kvUserInfo.encodedUserId;
        ProjectScope.setUserInfo(userInfo);
      }

      return ;
    }

    if (userInfo) {
      userInfo.fromQT = true;
    }

    // console.log(999, 'Sending userinfo to KV', userInfo);
    this.triggerInIframe(actionTypes.UPDATE_USER_INFO, userInfo, kvDocument);
    Config.kioskStandAlone && this.triggerInIframe(actionTypes.UPDATE_KV_FEATURES); // fires every time we switch to KV
  };

  triggerInIframe = (event, data, kvDocument) => {
    // console.log('QT - need to trigger in KV iFrame', data, kvDocument);
    let ifrm = document.getElementById(this.state.iframeId);
    if (ifrm) {
      const frmWindow = ifrm.contentWindow || ifrm.document.window;
      if (frmWindow) {
        // console.log('QT - triggered in KV iFrame');
        const frmDoc = ifrm.contentDocument || ifrm.contentWindow.document || ifrm.document;
        if (event === actionTypes.UPDATE_USER_INFO) {
          (kvDocument || frmDoc).updateUserInfo(event, data);
        } else if (event === actionTypes.UPDATE_KV_FEATURES) {
          if (frmWindow && frmWindow.updateKVFeatures) {
            frmWindow.updateKVFeatures(ProjectScope.quote(), ProjectScope.getIframeState()) // we need to pass quote and KV features
          }
        } else {
          frmWindow.$(frmWindow.document).trigger(event, data);
        }
      }
    }
  };

  kioskRegister = (e) => {
    if (parent.window.kioskGoToKV) {
      let ifrm = document.getElementById(this.state.iframeId);
      const fabricator = StonesStore.fabricator();
      const frmDoc = ifrm.contentDocument || ifrm.contentWindow.document || ifrm.document;
      const userInfo = ProjectScope.userInfo();
      frmDoc.kvConfig = {
        userId: fabricator.id,
        type: 'Fabricator',
        osk: true,
        homeUrl: fabricator.websiteUrl,
        kioskMode: true,
        hide: true,
        hideShadows: false,
        subdomain: Config.getSubdomain(),
        email: (userInfo || {}).email
      };

      const script = document.createElement('script');
      script.src = './kv.js';
      script.setAttribute('type', 'text/javascript');
      frmDoc.body.appendChild(script);
    }
  };

  render() {
    const {quote} = this.props;

    // console.log('quote-->', quote);

    //const Iframe = this.props.iframe;

    const canRenderKVButton = () => {
      const fabricator = StonesStore.fabricator();
      // return ProjectScope.isInKioskMode && quote.stone && quote.stone.HasKVLayer && fabricator.kitchenVisualizerEnabled;
      // console.log(999111, quote.stone, fabricator);
      return quote.stone && quote.stone.HasKVLayer && fabricator.KitchenVisualizerEnabled;
    };

    const url = this.renderIframeLink();

    return (

      <div className={"review-submit-iframe-wrapper"
      + (this.props.fullScreen ? ' review-submit-iframe-wrapper--fullscreen' : '')
      + (this.state.iframeOpened ? ' review-submit-iframe-wrapper--workaround' : '')
      + (this.props.isSelected ? ' review-submit-iframe-wrapper--active' : '')}>
        {!this.props.fullScreen && (
          (canRenderKVButton())
            ? (<div className="review-submit-iframe-wrapper-view">
                <div className="review-submit-iframe-wrapper-view-button"
                     onClick={e => this.handleViewInVisualizerClick(e)}>View in Visualizer
                </div>
              </div>
            ) : (
              <div className="review-submit-iframe-wrapper-layer">
                <div className="review-submit-iframe-wrapper-nokv">
                  <div className="review-submit-iframe-wrapper-nokv__button"
                       onClick={e => this.handleViewInVisualizerClick(e)}>Go to 3d visualizer
                  </div>
                  <div className="review-submit-iframe-wrapper-nokv__text"> Stone not Available in
                    Visualizer
                  </div>
                </div>
              </div>
            )
        )}
        <Iframe
          id={this.state.iframeId}
          src={this.props.fullScreen
            ? url + '&frame=1'
            : this.state.rendered ? (url + '&qt=1') : ''}
          name="kviframe"
          ref={(node) => {
            this.ifrmKV = node;
          }}
          onIframeLoad={this.kioskRegister}
          render={this.state.iframeRender}
        />
        <LoaderView visible={!this.state.iframeOpened} title="Loading..." iframe={true}
                    text="Please wait while Kitchen Visualizer is loaded"/>
        {!this.props.fullScreen && (
          <div className="review-submit-stone-listitemrenderer-text">
            <h10>{quote.stone && 'Stone Name: ' + quote.stone.Name}</h10>
            <h10>Price: ${quote.totalPrice.toFixed(2)}</h10>
          </div>
        )}
      </div>

    )
  }
}




// WEBPACK FOOTER //
// ./src/components/projectSummary/kitchenVisualizerIFrame.js